// src/store/modules/org.js
import apiClient from '@/axios';
import router from '@/router';
import { message } from 'ant-design-vue';

const state = {
  oppListData: {},
  oppViewData: [],
  personData: [],
  pipelineLevel: [],
  oppDropdowns: [],
  oppSuppliers: [],
  orgOtionsData: [],
  winProb: [],
  apiErrors: [],
  uploadFile: [],
  cmResponsibles: [],
  oppColumns: [],
  electra_link_set:false,
};

const getters = {
  getOppListData: (state) => state.oppListData,
  getoppViewData: (state) => state.oppViewData,
  getPersonsData: (state) => state.personData,
  getPipelineLevels: (state) => state.pipelineLevel,
  getoppDropdowns: (state) => state.oppDropdowns,
  getoppSuppliers: (state) => state.oppSuppliers,
  getorgOtionsData: (state) => state.orgOtionsData,
  getwinProb: (state) => state.winProb,
  getapiErrors: (state) => state.apiErrors,
  uploadFile: (state) => state.uploadFile,
  getCmResponsibles: (state) => state.cmResponsibles,
  getoppColumns: (state) => state.oppColumns,
  getElectraLink : (state) => state.electra_link_set,
};

const mutations = {
  SET_OPPORTUNITIES_LIST_DATA(state, data) {
    state.oppListData = data;
  },
  SET_PERSON_DATA(state, data) {
    state.personData = data;
  },
  SET_PIPELINE_DATA(state, data) {
    state.pipelineLevel = data;
  },
  SET_OPP_DROPDOWN_DATA(state, data) {
    state.oppDropdowns = data;
  },
  SET_OPP_SUPPLIERS(state, data) {
    state.oppSuppliers = data;
  },

  SET_OPPORTUNITY_OPTIONS(state, data) {
    state.orgOtionsData = data;
  },
  SET_OPPORTUNITY_VIEW_DATA(state, data) {
    state.oppViewData = data;
  },
  SET_WIN_PROB(state, data) {
    state.winProb = data;
  },
  SET_UPDATE_ERRORS(state, data) {
    state.apiErrors = data;
  },
  SET_UPLOAD_FILE(state, data) {
    state.uploadFile = data;
  },
  SET_CM_RESPONSIBLES(state, data) {
    state.cmResponsibles = data;
  },
  SET_COLUMNS(state, data) {
    state.oppColumns = data;
  },
  SET_ELECTRA_LINK(state, data) {
    state.electra_link_set = data;
  },
};

const actions = {
  async fetchOpportunitiesLists({ commit }, params) {
    try {
      const response = await apiClient.get('/opportunities', { params });
      commit('SET_OPPORTUNITIES_LIST_DATA', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching opportunity data:', error);
    }
  },

  async fetchOpportunityList({ commit }, params) {
    try {
      const response = await apiClient.get('/opportunities', { params });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching opportunity data:', error);
    }
  },

  async fetchOpportunity({ commit }, id) {
    try {
      const response = await apiClient.get(`/opportunity/view/${id}`);
      commit('SET_OPPORTUNITY_VIEW_DATA', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching opportunity data:', error);
    }
  },
  async getorgOptions({ commit },params) {
    try {
      const response = await apiClient.get('/organisations-dropdown',{
        params:{
          search:params?.search,
          page:params?.page
        }
      });
      if (response) {
        commit('SET_OPPORTUNITY_OPTIONS', response.data.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching types data:', error);
    }
  },
  async fetchPipelines({ commit }, { source } = {}) {
    try {
      const response = await apiClient.get('/pipeline-levels', {
        params: source ? { source } : {},
      });
      if (response) {
        commit('SET_PIPELINE_DATA', response.data.data);
        return response.data.data;
      }
    } catch (error) {
      console.error('Error fetching pipeline:', error);
    }
  },
  async fetchPersons({ commit }, orgId) {
    try {
      const response = await apiClient.get(`dropdown/organisation/${orgId}/persons`);
      if (response) {
        const modifiedResponse = response.data.data.map(person => ({
          id: person.id,
          name: (person.first_name) + ' ' + (person.last_name ? person.last_name : ''),
          email:person.email
        }
        ))
        commit('SET_PERSON_DATA', modifiedResponse);
        return modifiedResponse;
      }
    } catch (error) {
      console.error('Error fetching persons:', error);
    }
  },

  async fetchOpportunityOptions({ commit }, params) {
    try {
      const response = await apiClient.get('/settings/opportunity', { params });
      if (response) {
        commit('SET_OPP_DROPDOWN_DATA', response.data.data.dropdowns);
        commit('SET_OPP_SUPPLIERS', response.data.data.supplier);
        commit('SET_ELECTRA_LINK', response.data.data.electra_link_set);
        return response.data.data;
      }
    } catch (error) {
      console.error('Error fetching pipeline:', error);
    }
  },
  async fetchWinProb({ commit }, { pipelineID, selectedOppId }) {
    try {
      const response = await apiClient.get(`/opportunity/${selectedOppId}/pipeline-data/${pipelineID}`);
      if (response) {
        commit('SET_WIN_PROB', response.data.data);
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching win probability data:', error);
    }
  },

  async createOpportunity({ commit }, form) {
    try {
      const response = await apiClient.post(
        '/opportunity/create',
        form
      );
      if (response.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      console.error('Error saving Opportunity data:', error);
    }
  },

  async frsOpportunity({commit}, form) {
    try {
      const {oppId, payload} = form;
      const response = await apiClient.post(`/opportunity/duplicate/${oppId}`, payload);
      if(response?.status){
        // message.success(response?.data?.message);
        message.success("Re-Directed to New Meter Opportunity.");
      } else {
        message.error(response?.data?.message);
      } 
      return response?.data;
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  },

  async changeColumns({ commit }, form) {
    try {
      const response = await apiClient.post(
        '/user-form-fields/update',
        form
      );
      // if (response.status) {
      //   message.success(response.data.message);
      // }
      return response.data;
    } catch (error) {
      console.error('Error saving Opportunity data:', error);
    }
  },
  async getColumnsData({ commit }, type) {
    try {
      const getcol = await apiClient.get(`user-form-fields/${type}`);
      commit('SET_COLUMNS', getcol.data)
      return getcol.data;
    }
    catch (error) {
      console.error('Error saving Opportunity data:', error);
      return { success: false, errors: error.response.data.errors };
    }
  },
  async updateOpportunity({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/opportunity/update/${form.id}`,
        form,
      );
      if (response.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      commit('SET_UPDATE_ERRORS', error.response.data.errors)
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
      return { success: false, errors: error.response.data.errors };
    }
  },
  async uploadFile({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/document/upload`,
        form,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;

    } catch (error) {
      console.error('Error saving Opportunity data:', error);
      message.error(error.response.data.message);
      return { success: false, errors: error.response.data.errors };
    }
  },

  async getFiles({ commit }, id) {
    try {
      const getResponse = await apiClient.get(`opportunity/document-view/${id}`);
      commit('SET_UPLOAD_FILE', getResponse.data)
      return getResponse.data;
    }
    catch (error) {
      console.error('Error saving Opportunity data:', error);
      // message.error(error.response.data.errors);
      return { success: false, errors: error.response.data.errors };
    }
  },

  async deleteFile({ commit }, id) {
    try {
      const response = await apiClient.delete(`document/delete/${id}`);
      if (response.data.status) {
        message.success(response.data.message);
        return response.data;
      }
    }
    catch (error) {
      console.error('Error saving Opportunity data:', error);
      // message.error(error.response.data.errors);
      return { success: false, errors: error.response.data.errors };
    }
  },
  async fetchCMUsers({ commit }, territoryId) {
    try {
      // const params = territoryIds.map(id => `territory=${id}`).join('&');
      const response = await apiClient.get(`/cm-responsibles?territory=${territoryId}`);
      const resData = response.data.data.map((res) => ({
        id: res.id,
        name: res.last_name ? `${res.first_name} ${res.last_name}` : res.first_name,
      }));
      commit('SET_CM_RESPONSIBLES', resData);
      return resData; // Return data for use in component
    } catch (error) {
      console.error('Error fetching cm responsibles:', error);
    }
  },

  async updateCounter({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/opportunity/${form.opp_id}/increment`,
        form.data,
      );
      // if (response.status) {
      //   message.success(response.data.message);
      // }
      return response.data;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
      return { success: false, errors: error.response.data.errors };
    }
  },

  async createQuote({ commit }, form) {
    try {
      const response = await apiClient.post(
        '/opportunity/create-quote',
        form
      );
      if (response.data.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
    }
  },

  async updateQuote({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/opportunity/update-quote/${form.key}`,
        form,
      );
      if (response.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
      return { status: false, errors: error.response.data.errors };
    }
  },

  async renameFile({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/document/rename`,
        form,
      );
      if (response.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
    }
  },

  async updatePerson({ commit }, form) {
    try {
      const response = await apiClient.post(
        `/organisation/updatePersonEmail/${form.id}`,
        form,
      );
      if (response.status) {
        message.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error saving Opportunity data:', error);
      return { status: false, errors: error.response.data.errors };
    }
  },
  async createHotKey({ commit }, { oppId, payload }) {
  try {
    const response = await apiClient.post(`/opportunity/hotkey/${oppId}`, payload);
    if (response.data.status) {
      message.success(response.data.message || 'Hot Key created successfully');
    }
    return response.data;
  } catch (error) {
    message.error(error?.response?.data?.message || 'Hot Key creation failed');
    console.error('Error creating Hot Key:', error);
    return { success: false, errors: error?.response?.data?.errors };
  }
},
  async createOutbound({ commit }, { oppId, payload }) {
    try {
      const response = await apiClient.post(`/opportunity/outbound/${oppId}`, payload);
      if (response.data.status) {
        message.success(response.data.message || 'Outbound created successfully');
      }
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.message || 'Outbound failed');
      console.error('Error creating Outbound:', error);
      return { success: false, errors: error?.response?.data?.errors };
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

